import styled from '@emotion/styled';
import { FieldArray } from 'formik';
import useSmartField from 'hooks/useSmartField';
import { useTranslate } from '@tolgee/react';
import KnowledgeTypeRenderer from '@knowledge/knowledges/general/KnowledgeListForm/KnowledgeTypeRenderer';
import { ReactComponent as ArrowSvg } from './icon/arrow.svg';
import { ReactComponent as Num1Svg } from './icon/1.svg';
import { ReactComponent as Num2Svg } from './icon/2.svg';
import ConfigurationItem from './ConfigurationItem';
import { UnConfigStore } from 'views/BootGuide/views/AiModel/share';
import { useLabel } from '@knowledge/common/hooks/useGroup';
import { Store } from 'components/StoreScopes';

type ConfigurationPanelProps = {
  drawerIndex: number;
  type: Knowledge.KnowledgeType;
  stores?: Store[];
  storeMap: Partial<Record<number, UnConfigStore>>;
};

function ConfigurationPanel(props: ConfigurationPanelProps) {
  const { type, stores, storeMap } = props;
  const { t } = useTranslate();
  const { field } = useSmartField('conditions');
  const { knowledgeLabel } = useLabel();

  return (
    <Panel>
      <Condition>
        <Header fullBorder>
          <Num1Svg />
          <div>{t('knowledge.满足以下条件')}</div>
        </Header>
        <FieldArray name={`conditions`}>
          {(_arrayHelpers) => {
            return (
              <ConditionContent>
                {field?.value?.map((condition, index) => {
                  return (
                    <ConfigurationItem
                      key={index}
                      fieldNamePrefix={`conditions.${index}`}
                      stores={stores}
                    />
                  );
                })}
                {/*<Button onClick={() => arrayHelpers.push(newCondition())} block className="mt-[16px]" style={{color: 'var(--ant-primary-color)'}}  type="dashed">+ 新增条件</Button>*/}
              </ConditionContent>
            );
          }}
        </FieldArray>
      </Condition>
      <Shift>
        <ArrowSvg />
      </Shift>
      <Value>
        <Header>
          <Num2Svg />
          <div>{knowledgeLabel[type]}</div>
        </Header>
        <ValueContent>
          <KnowledgeTypeRenderer type={type} storeMap={storeMap} />
        </ValueContent>
      </Value>
    </Panel>
  );
}

const Panel = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  height: 100%;
`;

const Condition = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  overflow: hidden;
`;

const Shift = styled.div`
  flex-basis: 16px;
  padding-top: 12px;
`;

const Value = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  border: 1px solid rgba(240, 242, 245, 1);
`;

const Header = styled.div<{ fullBorder?: boolean }>`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  border: ${({ fullBorder = false }) => (fullBorder ? '1px solid rgba(240,242,245,1)' : 'none')};
  border-bottom: 1px solid rgba(240, 242, 245, 1);
  flex-shrink: 0;
  & > div {
    font-size: 14px;
    color: #84868c;
    margin-left: 6px;
  }
`;

const ValueContent = styled.div`
  padding: 16px;
  height: 100%;
  overflow: auto;
`;

const ConditionContent = styled.div`
  background: #f7f9fa;
  padding: 8px 16px 8px 8px;
  height: 100%;
  overflow: auto;
`;

export default ConfigurationPanel;
